// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3kYl4","errorLogs":"EditorFooter_errorLogs__12DX3"};